import React from 'react';
import PropTypes from 'prop-types';
import { Text, mergeClasses } from '@fluentui/react-components';
import { MusicNote2Filled } from '@fluentui/react-icons';
import { useStyles } from './style';
import { ScenePickerView } from './scene-picker';
import audioWaveImage from '../../media/audio-wave.svg';
import { getLocalizedAudioName } from '../audio-editor';

const TemplateContainer = ({ templateDetail, i18n, classes }) => {
  if (!templateDetail || !templateDetail.TemplateThumbnailUrl || !templateDetail.TemplateName) {
    return null;
  }

  return (
    <div className={mergeClasses(classes.templateContainer, 'template-container')} style={{ borderRadius: '10px' }}>
      <Text>{i18n.getString(_TL_('Selected Template'))}</Text>
      <img className={mergeClasses(classes.templateThumbnail, 'template-thumbnail')} src={templateDetail.TemplateThumbnailUrl} alt="template-thumbnail" />
      <div className={mergeClasses(classes.templateText, 'template-metadata')}>
        <div>{templateDetail.LocalizedTemplateName || templateDetail.TemplateName}</div>
        <div>{i18n.getString(_TL_('Duration: {{seconds}} seconds'), { seconds: templateDetail.Duration })}</div>
      </div>
    </div>
  );
};

TemplateContainer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  template: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    timestamp: PropTypes.string.isRequired,
  }).isRequired,
};

const AudioBar = ({ videoMetadata, i18n }) => {
  const classes = useStyles();
  const audio = videoMetadata.template && videoMetadata.template.audio;
  const audioName = audio && audio.audioName;
  const audioCategory = audio && audio.category;

  return (
    <div
      className={mergeClasses(classes.audioBar, 'audio-bar')}
      style={{
        borderRadius: '10px',
        overflow: 'hidden',
        backgroundImage: `url(${audioWaveImage}), linear-gradient(to right, rgba(0, 0, 255, 0.8), rgba(0, 0, 255, 1))`,
        backgroundPosition: 'center',
        backgroundRepeat: 'repeat-x',
      }}
    >
      <MusicNote2Filled fontSize={24} />
      <Text>{getLocalizedAudioName(audioName, i18n) || audioCategory}</Text>
    </div>
  );
};

AudioBar.propTypes = {
  videoMetadata: PropTypes.shape({
    audio: PropTypes.string.isRequired,
  }).isRequired,
};

export const StoryBoardView = ({
  i18n,
  scenes,
  selectedSceneId,
  onSceneSelected,
  videoMetadata,
  templateDetail,
}) => {
  const classes = useStyles();

  return (
    <div className={mergeClasses(classes.storyBoardView, 'story-board')} style={{ borderRadius: '10px' }}>
      <TemplateContainer i18n={i18n} templateDetail={templateDetail} classes={classes} />
      <div className={classes.navigationContainer}>
        <div className={mergeClasses(classes.scenesContainer, 'scenes-container')}>
          <ScenePickerView scenes={scenes} onSceneSelected={onSceneSelected} selectedSceneId={selectedSceneId} />
          <AudioBar videoMetadata={videoMetadata} i18n={i18n} />
        </div>
      </div>
    </div>
  );
};

StoryBoardView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  scenes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedSceneId: PropTypes.number.isRequired,
  onSceneSelected: PropTypes.func.isRequired,
  videoMetadata: PropTypes.shape({
    audio: PropTypes.string.isRequired,
  }).isRequired,
};
